import {Injectable} from '@angular/core';
import {CrudService} from '../../services';
import {Customer} from '../../dto/customer';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from '../../models/data-list-model';
import {DateTableFilter} from '../../table-datasouces/date-table-filter';
import {PrevNextModel} from '../../models/prev-next-model';
import {toISODateString} from '../../providers/app-date-adapter';
import {AddressUploadDto} from '../../dto/address-upload';
import {CustomerChangeAddressStatusModel} from '../../models/customer-change-address-status-model';
import {AddressFailReason} from "../../dto/address-fail-reason";

@Injectable({
  providedIn: 'root'
})
export class AddressCustomersService implements CrudService<Customer> {
  readonly apiPath = 'address-customers/';

  constructor(private http: HttpClient) {
  }

  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Customer>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string }
  ) {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('someAdditionalData', someAdditionalData);

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }


    return this.http.get(this.apiPath, {params}) as Observable<DataListModel<Customer>>;
  }

  getActiveInquiries(): Observable<number> {
    return this.http.get(this.apiPath + 'active-inquiries', {headers: {'skip-error-snack': 'true'}}) as Observable<number>;
  }

  add(item: Customer): Observable<Object> {
    throw new Error('Method not implemented.');
  }

  update(item: Customer) {
    throw new Error('Method not implemented.');
    item.cards = [];
    return this.http.put(this.apiPath, item) as Observable<Customer>;
  }

  delete(id: any) {
    throw new Error('Method not implemented.');
    return this.deleteMany([id]);
  }

  restore(id: any) {
    throw new Error('Method not implemented.');
    return this.restoreMany([id]);
  }

  deleteMany(idList: any[]): Observable<Object> {
    throw new Error('Method not implemented.');
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, {params: httpParams});
  }

  restoreMany(idList: any[]): Observable<Object> {
    throw new Error('Method not implemented.');
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, {params: httpParams});
  }

  getFilterParams(filters: DateTableFilter): HttpParams {
    const str = filters.str || '';
    const dateFilterCols = filters.dateFilterCols || [];
    const startFilterDate = filters.startFilterDate || null;
    const endFilterDate = filters.endFilterDate || null;

    let params = new HttpParams()


      .set('filterString', str)
      .set('someAdditionalData', filters.someAdditionalData)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate));
    if (filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }

    if (filters.enumFilter) {
      params = params.set('enumFilter', filters.enumFilter.value + '_' + filters.enumFilter.key);
    }


    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }

  getPrev(filters: DateTableFilter, customerId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/prev`, {params}) as Observable<number>;
  }

  getNext(filters: DateTableFilter, customerId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/next`, {params}) as Observable<number>;
  }

  getPrevNext(filters: DateTableFilter, customerId: number): Observable<PrevNextModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/prev-next`, {params}) as Observable<PrevNextModel>;
  }

  saveAddressFiles(files: AddressUploadDto[]): Observable<AddressUploadDto[]> {
    return this.http.post(this.apiPath, files) as Observable<AddressUploadDto[]>;
  }

  saveAddressFilesAndSendEmail(item: CustomerChangeAddressStatusModel) {
    return this.http.post(`${this.apiPath}save-address-status`, item) as Observable<boolean>;
  }

  getPossibleAddressFailReasons() {
    return this.http.get(`${this.apiPath}fail-reasons`) as Observable<AddressFailReason[]>;
  }

}
